import { WebApiModel } from '../../models/web-api.model';
import { RouteUrl } from '../../services/router-helper.service';

/** Search request type. */
export class SearchRequest {
  constructor(
    public keywords: string,
    public location: string, // Location name, i.e. 'Auckland'.
    public latitude: string,
    public longitude: string,
  ) {}
}

/** Item bound to the autocomplete dropdown list. */
export class AutocompleteUiItem {
  data: WebApiModel.AutocompleteItem;
  route: RouteUrl;
  selected: boolean;
  index: number;
  name: string;
  /* Places will have an extra bit of information - location. Use a generic name because AutocompleteUiItem is also used by the location autocomplete. */
  subName: string;
  isHeader: boolean;
  /** Person or place profile */
  isProfile: boolean;
  isClickable: boolean;
  cssClass: string;
  // When item is selected from the dropdown the input textbox is populated with the items name,
  // we don't want this behaviour for the autocomplte headers. This flag is a way to control the behaviour.
  populateInputWithName: boolean;

  // Populate the url search term with either what user typed in the input box
  // or full name of the selected item.
  // For example when when service name is clicked we pass the service name to search results.
  // When People or Places header is clicke in the autocomplete dropdown we pass what was entered in the input box.
  populateSearchTermWithName: boolean;
  /**
   * Flag indicating if the name will be highlighted as you type. Not all autocomplete items will need
   * name highlighted, for example People, Places, 'See all results' can't be highlighted.
   */
  highlightName: boolean;
}

/** Search response when getting autocomplete data from web api */
export class AutocompleteSearchResponse {
  constructor(
    public request: SearchRequest,
    public results: WebApiModel.AutocompleteItem[],
  ) {}
}

export class AutocompleteSelectedItem {
  autocompleteUiItem: AutocompleteUiItem;
  /** Search input at the time when item was selected from the dropdown list.  */
  searchInput: string;
  /** Search term to use on the search results page.  */
  searchTerm: string;
}

/** Settings can be passed from the parent component to override defaults (optional). */
export class AutocompleteSettings {
  inputDelay: number;
  inputMinChar: number;
  inputPlaceholder: string;
}
